import React from "react";
import { FaFlask, FaHeartbeat, FaAtom } from "react-icons/fa";
import ComingSoon from "../pages/ComingSoon";

const tests = [
  {
    id: 1,
    title: "Full Syllabus Mock Test 1",
    subject: "All Subjects",
    questions: 180,
    duration: "3 Hours",
    difficulty: "Hard",
  },
  {
    id: 2,
    title: "Biology Chapter Test",
    subject: "Biology",
    questions: 90,
    duration: "1.5 Hours",
    difficulty: "Medium",
  },
  {
    id: 3,
    title: "Physics Practice Test",
    subject: "Physics",
    questions: 45,
    duration: "1 Hour",
    difficulty: "Hard",
  },
  {
    id: 4,
    title: "Chemistry Quick Test",
    subject: "Chemistry",
    questions: 45,
    duration: "1 Hour",
    difficulty: "Easy",
  },
];

const getIcon = (subject) => {
  const style = { fontSize: "22px" };

  switch (subject) {
    case "Biology":
      return <FaHeartbeat style={{ ...style, color: "green" }} />;
    case "Physics":
      return <FaAtom style={{ ...style, color: "blue" }} />;
    case "Chemistry":
      return <FaFlask style={{ ...style, color: "purple" }} />;
    default:
      return <FaAtom style={{ ...style, color: "gray" }} />;
  }
};

const TextSeries = () => {
  return (
    
    <ComingSoon type="testSeries" />
    
    // <div
    //   style={{
    //     minHeight: "100vh",
    //     background: "#f3f4f6",
    //     padding: "20px",
    //   }}
    // >
    //   {/* Header */}
    //   <div style={{ marginBottom: "30px" }}>
    //     <h1
    //       style={{
    //         fontSize: "28px",
    //         fontWeight: "bold",
    //         color: "#1f2937",
    //       }}
    //     >
    //       NEET Test Series
    //     </h1>
    //     <p style={{ color: "#6b7280" }}>
    //       Practice with real exam-level mock tests
    //     </p>
    //   </div>

    //   {/* Grid */}
    //   <div
    //     style={{
    //       display: "grid",
    //       gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    //       gap: "20px",
    //     }}
    //   >
    //     {tests.map((test) => {
    //       const difficultyStyle = {
    //         Hard: { background: "#fee2e2", color: "#dc2626" },
    //         Medium: { background: "#fef3c7", color: "#d97706" },
    //         Easy: { background: "#dcfce7", color: "#16a34a" },
    //       };

    //       return (
    //         <div
    //           key={test.id}
    //           style={{
    //             background: "#fff",
    //             borderRadius: "16px",
    //             padding: "20px",
    //             boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    //             transition: "0.3s",
    //           }}
    //         >
    //           {/* Top */}
    //           <div
    //             style={{
    //               display: "flex",
    //               justifyContent: "space-between",
    //               marginBottom: "15px",
    //             }}
    //           >
    //             {getIcon(test.subject)}

    //             <span
    //               style={{
    //                 fontSize: "12px",
    //                 padding: "5px 10px",
    //                 borderRadius: "20px",
    //                 ...difficultyStyle[test.difficulty],
    //               }}
    //             >
    //               {test.difficulty}
    //             </span>
    //           </div>

    //           {/* Title */}
    //           <h2
    //             style={{
    //               fontSize: "16px",
    //               fontWeight: "600",
    //               color: "#1f2937",
    //               marginBottom: "10px",
    //             }}
    //           >
    //             {test.title}
    //           </h2>

    //           {/* Details */}
    //           <div
    //             style={{
    //               fontSize: "14px",
    //               color: "#6b7280",
    //               marginBottom: "15px",
    //             }}
    //           >
    //             <p>📘 Subject: {test.subject}</p>
    //             <p>📝 Questions: {test.questions}</p>
    //             <p>⏱ Duration: {test.duration}</p>
    //           </div>

    //           {/* Button */}
    //           <button
    //             style={{
    //               width: "100%",
    //               background: "#2563eb",
    //               color: "#fff",
    //               padding: "10px",
    //               borderRadius: "10px",
    //               border: "none",
    //               cursor: "pointer",
    //               fontWeight: "500",
    //             }}
    //           >
    //             Start Test
    //           </button>
    //         </div>
    //       );
    //     })}
    //   </div>
    // </div>
  );
};

export default TextSeries;